import { CircularProgress, Stack } from "@mui/material";
import { Alert } from "klayowebshared";
import { Component } from "react";
import { AppContext } from "../../common/AppContext";
import { MenuSelect } from "../../components/MenuSelect";
import { TextField } from "../../components/TextField";
import { Dialog } from "../../components/dialogs/Dialog";
import { CREATE_TASK_MODE } from "../../constants";
import { withLocale, WithLocaleProps } from "../../providers/LocaleProvider";

interface CreateRegulationDomainDialogProps extends WithLocaleProps {
  user?: any;
  theme?: any;
  onClose?: () => void;
  error?: string;
  mode?: number;
  selectedDomain?: any;
  selectedRegion?: any;
  loading?: boolean;
  onSave?: (data: any) => void;
  onGetListRegulationRegion?: () => Promise<any>;
}

class CreateRegulationDomainDialogBase extends Component<CreateRegulationDomainDialogProps, any> {
  static contextType = AppContext;
  declare context: React.ContextType<typeof AppContext>;

  constructor(props: any) {
    super(props);

    this.state = {
      domain: null,
      region: null,
      regions: []
    };
  }

  componentDidMount() {
    const { mode, selectedRegion, selectedDomain } = this.props;
    if (mode === CREATE_TASK_MODE.EDIT) {
      this.setState({
        domain: selectedDomain.name,
        region: selectedDomain.regionRowId
      });
    }

    if (selectedRegion) {
      this.setState({ region: selectedRegion.id });
    }
    this.onFetchRegions();
  }

  async onFetchRegions() {
    const { onGetListRegulationRegion } = this.props as any;

    const regions = await onGetListRegulationRegion();

    this.setState({
      regions
    });
  }

  onSave() {
    const { onSave, selectedDomain } = this.props as any;
    const { domain, region } = this.state;
    if (onSave)
      onSave({
        domain,
        domainId: selectedDomain?.id,
        regionId: region
      });
  }

  onUpdateName(e: any) {
    this.setState({ domain: e.target.value });
  }

  onFormatListRegulationDomain(regions: any) {
    if (regions) {
      const newFormattedTypes = regions.reduce((acc: any, curr: any) => {
        acc[curr.id] = {
          id: curr.id,
          name: curr.name,
          value: curr.id,
          label: curr.name
        };
        return acc;
      }, {});
      return Object.values(newFormattedTypes);
    }
    return null;
  }

  onSelectItem(event: any) {
    this.setState({ region: event.target.value });
  }

  findSelectedRegion() {
    const { regions, region } = this.state;
    const { mode } = this.props;

    if (mode === CREATE_TASK_MODE.EDIT) {
      return regions.find((item: any) => item.id === region)?.name;
    }

    return "";
  }

  render() {
    const {
      user,
      theme,
      onClose,
      error,
      mode,
      selectedDomain,
      loading,
      selectedRegion,
      translate
    } = this.props;
    const { domain, regions, region } = this.state;

    return (
      <Dialog
        open={true}
        theme={theme}
        onClose={onClose}
        fullWidth={true}
        maxWidth='sm'
        title={
          mode === CREATE_TASK_MODE.EDIT
            ? translate("settings.editDomain")
            : translate("settings.createDomain")
        }
        actions={[
          {
            label:
              mode === CREATE_TASK_MODE.EDIT
                ? translate("common.save")
                : translate("common.create"),
            primary: true,
            disabled:
              !domain ||
              !region ||
              (mode === CREATE_TASK_MODE.EDIT &&
                domain === selectedDomain.name &&
                region === selectedDomain.regionRowId) ||
              loading,
            onClick: this.onSave.bind(this) as any,
            icon: loading && <CircularProgress size={20} />
          },
          {
            label: translate("common.cancel"),
            onClick: onClose as any,
            disabled: loading
          }
        ]}
      >
        <Stack direction='column' spacing={4}>
          {error && (
            <Alert severity='error' sx={{ width: "100%" }}>
              {error}
            </Alert>
          )}

          <MenuSelect
            className='klayo_practical-type-select-menu'
            label={translate("settings.jurisdictionRequired")}
            value={region}
            firstValueDefault={false}
            noSelectionError={true}
            dense={true}
            items={this.onFormatListRegulationDomain(regions) as any}
            onChange={this.onSelectItem.bind(this) as any}
            sx={{ width: "100%" }}
            placeholder={translate("settings.selectJurisdiction")}
            clearable={false}
            disabled={!!selectedRegion || !!selectedDomain}
          />

          <TextField
            value={domain}
            label={translate("settings.domainNameRequired")}
            dense={true}
            disabled={user === null}
            autoComplete={false}
            autoFocus={false}
            sx={{ width: "100%" }}
            onChange={this.onUpdateName.bind(this)}
          />
        </Stack>
      </Dialog>
    );
  }
}

export const CreateRegulationDomainDialog = withLocale(CreateRegulationDomainDialogBase);
